//////////////////////////////////////////////////////////////
//     							                                        //
//  Program: ListingAvailabilityRule.js                     //
//  Application: ListingAvailabilityRule                    //
//  Option: Used for manage Listing Availability Rule       //
//  Developer: Ashish Kumar  						                    //
//  Date: 2025-06-25                                        //
//                                                          //
//////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class ListingAvailabilityRuleService {
  getListingAvailabilityRule(queryString) {
    let endPoint =
      "get-listing-availability-rule" + (queryString ? "?" + queryString : "");
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  addOrUpdateListingAvailabilityRule(data) {
    delete data.errors;
    delete data.input;

    let endPoint = "add-update-listing-availability-rule";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new ListingAvailabilityRuleService();
